module.exports = __webpack_public_path__ + "media/images/landing/icons/telegram-87d0ea817f5b53b15549f43489ddf4b8.svg";